import Swal from 'sweetalert2'

const artistFormWidget = {
    isLoading: false,
    init() {
        $(document).on('click', '.artist-form-next-step-btn', this, this.nextStep);
        $(document).on('click', '.artist-form-back-step-btn', this, this.back);
    },
    nextStep(event) {
        const _this = event.data;
        event.preventDefault();

        let mid = $(this).data('mid');
        let step = $(this).data('step');

        if (_this.isLoading) {
            return false;
        }

        $('.artist-form').find('.form-control').removeClass('is-invalid');
        $('.artist-form').find('.form-check-input').removeClass('is-invalid');

        //Loading...
        _this.isLoading = true;
        let element = this;
        $(element).find('i').show();

        var values='';
        values+='module_id=' + encodeURIComponent(mid);
        values+='&step=' + encodeURIComponent(step);
        values+='&_token=' + encodeURIComponent($('meta[name="csrf-token"]').attr("content"));

        switch (step) {
            case 1:
                values+='&name=' + encodeURIComponent($('#af_name').val());
                values+='&email=' + encodeURIComponent($('#af_email').val());
                values+='&phone=' + encodeURIComponent($('#af_phone').val());
                values+='&date_of_birth=' + encodeURIComponent($('#af_date_of_birth').val());
                values+='&date_of_death=' + encodeURIComponent($('#af_date_of_death').val());
                values+='&nationality=' + encodeURIComponent($('#af_nationality').val());
                values+='&terms_and_conditions=' + encodeURIComponent(($('#af_terms_and_conditions').is(":checked")?1:''));
                values+='&newsletter=' + encodeURIComponent(($('#af_newsletter').is(":checked")?1:0));
                break;

            case 2:
                var thematics = $('input[name="af_thematics[]"]:checked').map(function() {
                    return this.value;
                }).get().join(',');

                var materials = $('input[name="af_materials[]"]:checked').map(function() {
                    return this.value;
                }).get().join(',');

                var art_types = $('input[name="af_art_types[]"]:checked').map(function() {
                    return this.value;
                }).get().join(',');

                var techniques = $('input[name="af_techniques[]"]:checked').map(function() {
                    return this.value;
                }).get().join(',');

                var styleVal = $('input[name="af_style"]:checked').val();
                values += '&style=' + encodeURIComponent((typeof styleVal !== 'undefined' ? styleVal : ''));
                values += '&style_other=' + encodeURIComponent($('#af_style_other_value').val());
                values += '&thematics=' + encodeURIComponent(thematics);
                values += '&thematic_other=' + encodeURIComponent($('#af_thematic_other_value').val());
                values += '&materials=' + encodeURIComponent(materials);
                values += '&material_other=' + encodeURIComponent($('#af_material_other_value').val());
                values += '&art_types=' + encodeURIComponent(art_types);
                values += '&art_type_other=' + encodeURIComponent($('#af_art_type_other_value').val());
                values += '&techniques=' + encodeURIComponent(techniques);
                values += '&technique_other=' + encodeURIComponent($('#af_technique_other_value').val());
                values += '&artist_statement=' + encodeURIComponent($('#af_artist_statement').val());
                break
                
            case 3: 
                values += '&exhibition_locations=' + encodeURIComponent($('#af_exhibition_locations').val());
                values += '&exhibit_events_participations=' + encodeURIComponent($('#af_exhibit_events_participations').val());
                values += '&collective_exhibitions=' + encodeURIComponent($('#af_collective_exhibitions').val());
                values += '&artistic_residencies=' + encodeURIComponent($('#af_artistic_residencies').val());
                break;

            case 4: 
                values += '&awards_and_recognitions=' + encodeURIComponent($('#af_awards_and_recognitions').val());
                values += '&artistic_education_training=' + encodeURIComponent($('#af_artistic_education_training').val());
                values += '&important_collaborations=' + encodeURIComponent($('#af_important_collaborations').val());
                values += '&collaborations_with_curators=' + encodeURIComponent($('#af_collaborations_with_curators').val());
                values += '&international_collaborations=' + encodeURIComponent($('#af_international_collaborations').val());
                break;
            
            case 5: 
                values += '&price_history_galleries=' + encodeURIComponent($('#af_price_history_galleries').val());
                values += '&price_history_auction_house=' + encodeURIComponent($('#af_price_history_auction_house').val());
                values += '&feedback_from_critics_and_art_collectors=' + encodeURIComponent($('#af_feedback_from_critics_and_art_collectors').val());
                values += '&media_and_online_presence=' + encodeURIComponent($('#af_media_and_online_presence').val());
                break;

            case 6: 
                values += '&ongoing_projects=' + encodeURIComponent($('#af_ongoing_projects').val());
                values += '&future_objectives=' + encodeURIComponent($('#af_future_objectives').val());
                values += '&art_examples_portofolio=' + encodeURIComponent($('#af_art_examples_portofolio').val());
                values += '&additional_observations=' + encodeURIComponent($('#af_additional_observations').val());
                break;
        
            default:
                Swal.fire({
                    text: 'Invalid step',
                });
                return;
                break;
        }
    
        $.ajax({
            type: "POST",
            url: baseURL + '/artist-form/send',
            data: values,
            success: function(response) {
                _this.isLoading = false;
                $(element).find('i').hide();

                if (response.status == 0) {
                    var errorHtml = '';
                    for(var errorKey in response.errors) {
                        if(!response.errors.hasOwnProperty(errorKey)) continue;
                        for(var error in response.errors[errorKey]) {
                            $('#af_' + errorKey).addClass('is-invalid');
                            errorHtml += response.errors[errorKey][error] + '<br>';
                        }
                        //$("#"+errorKey).closest('.form-group').addClass('has-error');
                        //$("#"+errorKey).css('border', '1px solid red');
                    }
                    Swal.fire({
                        html: errorHtml
                    });
                    return false;
                }

                if (response.status == 1) {
                    
                    if (response.step == 'final') {
                        $('.artist-form-steps-container').html(response.message);
                        return true;
                    }

                    for (let i = 1; i <= response.step; i++) {
                        $('.artist-step-' + i).addClass('active');
                    }

                    $('.artist-form-steps-container').html(response.html);

                    return true;
                }

                Swal.fire({
                    text: response.message
                });
            },
            error(error) {
                _this.isLoading = false;
                $(element).find('i').hide();
            },
        });
    },
    back(event) {
        const _this = event.data;
        event.preventDefault();
        let mid = $(this).data('mid');

        if (_this.isLoading) {
            return false;
        }

        //Loading...
        _this.isLoading = true;
        let element = this;
        // $(element).find('i').show();

        var values='';
        values+='module_id=' + encodeURIComponent(mid);
        values+='&_token=' + encodeURIComponent($('meta[name="csrf-token"]').attr("content"));
        $.ajax({
            type: "POST",
            url: baseURL + '/artist-form/back',
            data: values,
            success: function(response) {
                _this.isLoading = false;
                // $(element).find('i').hide();

                if (response.status == 1) {
                    for (let i = 1; i <= response.step; i++) {
                        $('.artist-step-' + i).addClass('active');
                    }

                    $('.artist-form-steps-container').html(response.html);

                    return true;
                }

                Swal.fire({
                    text: response.message
                });
            },
            error(error) {
                _this.isLoading = false;
                // $(element).find('i').hide();
            },
        });

    },
};

$(document).ready(function() {
    if ($('.artist-form-module').length) {
        artistFormWidget.init();
    }
});